import { Flex, Text, Th, Thead, Tr } from '@chakra-ui/react';
import { IterationComponent } from '@components/functionComponent';
import SortTableIcon from '@components/tableTemplate2/components/sortIcon';

export default function TableHeadComp({ tableList, fontSize, onSort, sortType, ...props }) {
    return (
        <Thead {...props}>
            <Tr>
                <IterationComponent
                    arr={tableList}
                    render={({ title, width, value, withSort, justifySelf }, idx) => {
                        return (
                            <Th
                                key={idx}
                                width={`${width}px`}
                                maxWidth={`${width}px`}
                                p={'16px 12px'}
                                fontSize={fontSize}
                                fontWeight={'500'}
                                textTransform={'capitalize'}
                            >
                                <Flex
                                    gap="8px"
                                    alignItems="center"
                                    justifySelf={justifySelf}
                                    onClick={() => withSort && onSort(value)}
                                    cursor={withSort ? 'pointer' : 'default'}
                                >
                                    <Text>{title}</Text>
                                    <SortTableIcon sortType={sortType} withSort={withSort} value={value} />
                                </Flex>
                            </Th>
                        );
                    }}
                />
            </Tr>
        </Thead>
    );
}
